import preset from '../preset';

export type gap = number;

export const gapClass = preset.xclasses<gap>('gap');

export default gapClass;
